import * as React from 'react';
import { Lock, Wrench } from 'lucide-react';
import './SkillPicker.css';

/** Placeholder for user-defined custom skills (dashboard-managed, coming soon). */
export const CustomSkillsPanel: React.FC = () => (
  <div className="skill-picker">
    <p className="skill-picker-intro">
      Run skills you define in the Courtyard dashboard — instructions and tools tailored to your
      team.
    </p>
    <div className="skill-picker-custom skill-picker-custom--standalone">
      <div className="skill-picker-custom-header">
        <Wrench size={14} aria-hidden />
        <span>Skills</span>
      </div>
      <p className="skill-picker-custom-desc">
        Create, edit, and share skill definitions from the dashboard. They will appear here when
        available.
      </p>
      <div className="skill-picker-custom-lock-row">
        <Lock size={16} aria-hidden />
        <span>Coming soon</span>
      </div>
      <button type="button" className="skill-picker-custom-btn" disabled>
        Create skill
      </button>
    </div>
  </div>
);
